import styled from 'styled-components';

const DivContainer = styled.div`
  width: 250px;
`;

export default DivContainer;
